exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AdGroupBox{background:transparent;-webkit-box-shadow:unset;box-shadow:unset;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.AdGroupBox .mt20{border-radius:15px;overflow:hidden}.AdGroupBox .el-dialog__body{padding:0}.AdGroupBox .el-dialog__body img{width:100%}.AdGroupBox .el-dialog__header{position:absolute;color:#fff;padding:0;right:-50px;top:-50px}.AdGroupBox .el-dialog__header .el-dialog__headerbtn .el-dialog__close{color:#fff;background:rgba(0,0,0,.3);padding:6px;border-radius:20px;border:1px solid hsla(0,0%,100%,.5)}", ""]);

// exports
